var g2svg = require('./instance.js');
var geojson2svg = function(options) {
  return new g2svg(options);
};

module.exports = geojson2svg;
